module.exports = __webpack_public_path__ + "img/post_new.6d1e97e9.svg";